var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
import { makeAutoObservable } from "mobx";
import { perRestaurant } from "../../di";
import { ProductInstancePureAvailabilityService } from "./ProductInstancePureAvailabilityService";
import { FulfillmentTimeScope } from "../FulfillmentTimeScope";
import { inject } from "tsyringe";
import { FulfillmentInstructions, FulfillmentInstructionsToken, } from "../FulfillmentInstructions";
let ProductInstanceAvailabilityService = class ProductInstanceAvailabilityService {
    constructor(productInstancePureAvailabilityService, fulfillmentTimeScope, fulfillmentInstructions) {
        this.productInstancePureAvailabilityService = productInstancePureAvailabilityService;
        this.fulfillmentTimeScope = fulfillmentTimeScope;
        this.fulfillmentInstructions = fulfillmentInstructions;
        makeAutoObservable(this);
    }
    availability(productInstance) {
        return this.productInstancePureAvailabilityService.availability({
            productInstance,
            fulfillmentTime: this.fulfillmentTimeScope.fulfillmentTime,
            fulfillmentMethod: this.fulfillmentInstructions.fulfillmentMethod,
        });
    }
};
ProductInstanceAvailabilityService = __decorate([
    perRestaurant(),
    __param(2, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductInstancePureAvailabilityService !== "undefined" && ProductInstancePureAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof FulfillmentTimeScope !== "undefined" && FulfillmentTimeScope) === "function" ? _b : Object, typeof (_c = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _c : Object])
], ProductInstanceAvailabilityService);
export { ProductInstanceAvailabilityService };
